import { HttpService } from '@/infra'
import type { TEnviarDocumentoResponse, TTipoDocumento } from '@/shared//envio-documentos'
import { StringUtils } from '@/utils'

interface TEnviarDocumentoLead {
  clienteId: string
  arquivo: File
  tipo: TTipoDocumento
}

export class EnviarDocumentoLeadService extends HttpService {
  execute = async ({ clienteId, arquivo, tipo }: TEnviarDocumentoLead) => {
    const formData = new FormData()
    formData.append('Arquivo', arquivo)
    formData.append('NomeArquivo', StringUtils.removeAcentos(arquivo.name))
    formData.append('ClienteId', clienteId)
    formData.append('TiposDocumento', tipo)

    return this.http.post<TEnviarDocumentoResponse>('/api/v2/Documentos/represamento', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
}
